import { createFileRoute } from '@tanstack/react-router';

import { z } from 'zod';

export const Route = createFileRoute('/_auth')({
  validateSearch: z.object({
    next: z.string().optional().catch(''),
  }),
});
